<template>
  <v-dialog
      overlay-color="grey"
      overlay-opacity="0.5"
      :value="dialog"
      @input="dialog = $event"
      max-width="1500"
      scrollable
  >
    <v-card class="p-0" :color=" this.$vuetify.theme.dark ? '#121212' : '#fff'" height="100%">
      <card-class
            :selected-assign="selectedAssign"
            :user="user"
            :called-page-type="calledPageType"
        >
        <template v-slot:title>
          <v-card-title> 수강 상세 정보</v-card-title>
          <v-card-subtitle>Assign Id : {{ selectedAssign.assignId  }}</v-card-subtitle>
        </template>
      </card-class>
      <v-card-actions>
        <v-col>
          <v-row class="justify-end">
            <v-col cols="4" sm="3" >
              <v-btn color="primary darken-4" width="95%" small dark label="Payment Receipt" @click="linkReceipt(selectedAssign)">영수증</v-btn>
            </v-col>
            <v-col cols="4" sm="3" >
              <v-btn color="blue darken-4" width="95%" small dark label="Payment Receipt" @click="linkAssignSheet(selectedAssign)">수강증</v-btn>
            </v-col>
            <v-col cols="4" sm="3" >
              <v-btn color="secondary"      width="95%"  small dark label="Attendance Sheet" @click="sendAttendanceSheet(true)">출석증</v-btn>
            </v-col>
          </v-row>
          <v-row class="justify-end" >
            <v-col cols="4" sm="3" v-if="isChangable">
              <v-btn color="primary" width="95%" small dark @click="$emit('saveAssign', selectedAssign)">저장</v-btn>
            </v-col>
            <v-col cols="4" sm="3" >
              <v-btn color="gray "  width="95%" small dark @click="$emit('hideDialog')">닫기</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import apiPayment from "@/api/modules/api-payment";
import CardClass from "@/components/Card/CardClass";
import apiPdf from "@/api/modules/api-pdf";

export default {
  name: 'DialogClass',
  components: {CardClass  },
  props: {
    value: {type: Boolean, required: true},
    selectedAssign: {type: Object},
    calledPageType: {type: String, default: ''}
  },
  data(){
    return {
      datePickerMenu: false,
      timePickerMenu: false,
      attendList: [],
      listLoading: true,

      skypeIdRule: [v => !!v || 'Teams 혹은 Zoom 계정 입력해주세요.'],
    }
  },
  computed: {
    ...mapGetters(['app','user','isOwner','isManager', 'assign']),
    dialog: {
      get() {return this.value},
      set(value) {this.$emit('input', value)},
    },
    isAssign() {
      return this.calledPageType.includes('Assign')
    },
    isRegister() {
      return this.calledPageType.includes('Register')
    },
    isChangable() {
      return this.selectedAssign.assignStatus !== 'END' && this.selectedAssign.assignStatus !== 'STOP'
    }
  },
  created() { },
  beforeMount() { },
  mounted() { },
  methods: {
    ...mapActions(['fetchClassStartTime', 'fetchAssign']),
    linkReceipt(){
      apiPayment.receiptUrl(this.selectedAssign.orderId)
        .then(receiptLink => this.$openWindow(receiptLink, 'book'))
    },
    linkAssignSheet(){
      apiPdf.getAssignSheetPopup(this.selectedAssign.assignId)
    },
    sendAttendanceSheet(isFake){
      apiPdf.getAttendSheetPopup(this.selectedAssign.assignId, isFake)
          .then(() => this.$dialog.notify.success('출석확인증 이메일로 발송되었습니다.', {position: 'top-right', timeout: 1000}))
          .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right', timeout: 1500}))
    },
  },

}
</script>
